import request from '@/utils/request'
import qs from 'qs'
import md5 from '../utils/md5.js'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function loginByTelephone(data) {
  return request({
    url: '/user/loginByTelephone',
    method: 'post',
    data
  })
}

export function loginTest(username,password,type,telephone) {
  let ecrPassword = md5.hex_md5(password)
  let url = '/user/loginTest?username='+username + '&password=' + ecrPassword + '&type=' + type + '&telephone=' + telephone
  return request({
    url: url,
    method: 'get'
  })
}

export function adminLogin(username,password){
  const ecrPassword = md5.hex_md5(password)
  let data = {
    username:username,
    password:ecrPassword
  }
  return request({
    url: '/user/adminLogin',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'post',
    params: { token }
  })
}

export function initAbility(){
  return request({
    url:'/user/initAbility',
    method:'get'
  })
}

export function changeUser(token) {
  return request({
    url: '/job/changeUser',
    method: 'post',
    params: {  }
  })
}

export function updateToken() {
  return request({
    url: '/user/updateToken',
    method: 'post'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function getUserEnterpriseInfo(id) {
  return request({
    url: '/user/enterprise/getEnterpriseInfo',
    method: 'get',
    params:{id:id}
  })
}

export function applyHR(data){
  return request({
    url: '/user/identityUser/applyHR',
    method: 'post',
    data
  })
}


export function updatePassword(data){
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data
  })
}

export function listUserByIds(data){
  return request({
    url: '/user/identityUser/listUserByIds',
    method: 'post',
    data
  })
}

export function getUserList(data){
  return request({
    url: '/user/identityUser/getUserList',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}

export function getMyInfoFinishPercent(data){
  return request({
    url: '/user/enterprise/getMyInfoFinishPercent',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js